"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpoints = void 0;
exports.endpoints = {
    graphqlHost: "rsonavigator.ru",
    graphqlEndpoint: "/graphql",
    graphqlUseSSL: true,
    webHost: "rsonavigator.ru",
    webUseSSL: true,
};
//# sourceMappingURL=endpoints.js.map